'use-strict';

var VIDEO_STATUS_QUEUED = 1;
module.exports.VIDEO_STATUS_QUEUED = VIDEO_STATUS_QUEUED;

var VIDEO_STATUS_UPLOADING = 2;
module.exports.VIDEO_STATUS_UPLOADING = VIDEO_STATUS_UPLOADING;

var VIDEO_STATUS_ERROR = 3;
module.exports.VIDEO_STATUS_ERROR = VIDEO_STATUS_ERROR;

var VIDEO_STATUS_AVAILABLE = 4;
module.exports.VIDEO_STATUS_AVAILABLE = VIDEO_STATUS_AVAILABLE;

var VIDEO_STATUS_PROCESSED = 5;
module.exports.VIDEO_STATUS_PROCESSED = VIDEO_STATUS_PROCESSED;

var VIDEO_STATUS = {
  QUEUED: VIDEO_STATUS_QUEUED,
  UPLOADING: VIDEO_STATUS_UPLOADING,
  ERROR: VIDEO_STATUS_ERROR,
  AVAILABLE: VIDEO_STATUS_AVAILABLE,
  PROCESSED: VIDEO_STATUS_PROCESSED,
};
module.exports.VIDEO_STATUS = VIDEO_STATUS;
